module.exports = __webpack_public_path__ + "static/media/Croatia.31adb545.png";